import React, { useState } from 'react';
import styles from '../../Invoicing.module.css';

const faqData = [
  {
    q: 'How do my customers pay an invoice?',
    a: 'Every invoice includes a Pay Now button. Customers can pay with Fyntiq Wallet, card, Apple Pay, Google Pay, Cash App Pay, bank transfer, or financing — no account required.',
  },
  {
    q: 'Can I customize how invoices look?',
    a: 'Yes. Add your logo and brand colors, rearrange line items with drag-and-drop, include a custom message, and save templates to reuse.',
  },
  {
    q: 'Will I know when an invoice is paid?',
    a: "You're notified the moment a payment comes in, and a receipt is logged automatically. Your invoice list always shows what's paid, due, or overdue.",
  },
  {
    q: 'Can I send the same invoice on a schedule?',
    a: 'Yes — turn any invoice into a recurring schedule for retainers and subscriptions. See the Recurring Billing feature for details.',
  },
  {
    q: 'Is there a fee to send invoices?',
    a: "Sending invoices is free. You only pay standard per-transaction processing when you get paid. See the Pricing page for details.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Invoicing questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div className={styles.faqQ} onClick={() => setOpenIndex(openIndex === i ? -1 : i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}>
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
